var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 252,
  height: 291,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.734 183.37c15.739-23.079 29.692.727 54.097-34.676 17.984-26.09 74.379 10.054 74.821 41.611.348 24.822-49.844-16.888-66.106 18.765-9.485 20.795-39.97 54.529-60.324 36.603-10.075-8.873-18.228-39.224-2.488-62.303Z",
  fill: "#81B1B0",
  fillOpacity: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M165.547 21.02c23.743 11.259 2.186 35.724 38.634 53.307 26.86 12.957 18.385 84.617-11.945 95.471-23.857 8.537-50.482-35.695-86.378-43.464-20.937-4.531-19.163-63.8.089-71.303 13.602-5.3 35.856-45.27 59.6-34.011Z",
  fill: "#81B1B0",
  fillOpacity: 0.3
})));
export default SvgBgMobile;